<script setup lang="ts">
/*
 * Main app layout: top bar + content area + global Toaster.
 *
 * The outermost wrapper carries the `app-shell` class so the
 * proto-ported CSS in `./shell-styles.css` scopes correctly. Auth
 * routes (`meta.layout === 'auth'`) render outside this shell — see
 * `App.vue`.
 *
 * The shell receives org + user via props; emits the user-action
 * events (sign-out, change-password, etc.) so the App-level handler
 * keeps the change-password modal floating above the layout
 * regardless of the current route.
 */
import TopBar from './TopBar.vue';
import { Toaster } from '@/ui';

import './shell-styles.css';

withDefaults(
  defineProps<{
    user?: { name: string; email: string };
  }>(),
  {
    user: () => ({ name: 'Demo User', email: 'demo@optimalhr.com' }),
  },
);

defineEmits<{
  signOut: [];
  changePassword: [];
  viewProfile: [];
  search: [];
  openNotifications: [];
}>();
</script>

<template>
  <div class="app-shell flex min-h-screen flex-col" style="background: var(--oh-bg)">
    <TopBar
      :user="user"
      @sign-out="$emit('signOut')"
      @change-password="$emit('changePassword')"
      @view-profile="$emit('viewProfile')"
      @search="$emit('search')"
      @open-notifications="$emit('openNotifications')"
    >
      <template v-if="$slots.subnav" #subnav>
        <slot name="subnav" />
      </template>
    </TopBar>
    <main class="flex-1">
      <slot />
    </main>
    <Toaster />
  </div>
</template>
